interface BrandProps {
  href?: string
  label?: string
}

export function Brand({ href = '/', label = 'ihatecp home' }: BrandProps) {
  return (
    <a className="brand" href={href} aria-label={label}>
      i<span>hate</span>cp<span className="dot">.</span>
    </a>
  )
}

export function ArrowUpRight() {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M5 15 15 5M7 5h8v8" />
    </svg>
  )
}
